import createLazyComponent from '../LazyComponent';

const Home = createLazyComponent(() => import('./HomePage'));

export { Home as HomePage };
export default Home;
